import type React from "react";
import { UserProfilePopupWrapper } from "@/components/common/UserProfilePopupWrapper";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import type { PopupDisplayConfig } from "@/features/user-profile/types";

interface UserAvatarWithPopupProps {
  userId?: number;
  userName: string;
  avatarUrl?: string | null;
  currentUserId?: number | string;
  onSendMessage?: (userId: number) => void;
  wrapperClassName?: string;
  avatarClassName?: string;
  avatarFallbackClassName?: string;
  config?: Partial<PopupDisplayConfig>;
}

export const UserAvatarWithPopup: React.FC<UserAvatarWithPopupProps> = ({
  userId,
  userName,
  avatarUrl,
  currentUserId,
  onSendMessage,
  wrapperClassName,
  avatarClassName,
  avatarFallbackClassName,
  config = { trigger: "click", usePortal: true },
}) => {
  const avatar = (
    <Avatar className={avatarClassName}>
      <AvatarImage src={avatarUrl || ""} alt={userName} />
      <AvatarFallback className={avatarFallbackClassName}>
        {userName?.[0]}
      </AvatarFallback>
    </Avatar>
  );

  if (!userId) {
    return avatar;
  }

  return (
    <UserProfilePopupWrapper
      userId={userId}
      userName={userName}
      avatarUrl={avatarUrl ?? null}
      currentUserId={currentUserId}
      onSendMessage={onSendMessage}
      config={config}
      className={wrapperClassName}
    >
      {avatar}
    </UserProfilePopupWrapper>
  );
};
